/* eslint-disable prettier/prettier */
import React from 'react';

const Info: React.FC = () => (
  <>
    <div className="container">
      <div className="row">
        <div className="col-sm footer-info text-center">
          <p>
            PARA MAIS INFORMAÇÕES LIGUE 51 3213 1338
            {' '}
            <br />
            OU ENVIE E-MAIL PARA
            {' '}
            <a href="mailto:comercial@jornaldocomercio.com.br">comercial@jornaldocomercio.com.br</a>
          </p>
        </div>
      </div>
    </div>
  </>
);

export default Info;
